import React, { ReactElement } from "react";
import Link from "next/link";
import styles from "./contactOptions.module.scss";
import { getCmsIcon } from "@kunduz/utility-common";

export const HeaderContactOptions = (props: Props): ReactElement => {
  const renderItem = (
    icon: string,
    label: string,
    target: "_self" | "_blank" | "_parent" | "_top",
    value: string,
  ) => {
    const Icon = getCmsIcon(icon);

    return (
      <Link href={value} target={target} className={styles.link}>
        <Icon width={20} height={20} />
        {label}
      </Link>
    );
  };

  const leftItems =
    props.items?.filter((item) => item.position === "left") ?? [];
  const rightItems =
    props.items?.filter((item) => item.position === "right") ?? [];

  return (
    <section className={styles.base}>
      <div className={styles.wrapper}>
        {leftItems.length > 0 && (
          <div className={styles.alignment}>
            {leftItems.map((item, i) => (
              <React.Fragment key={i}>
                {renderItem(item.icon, item.label, item.target, item.value)}
              </React.Fragment>
            ))}
          </div>
        )}
        {rightItems.length > 0 && (
          <div className={styles.alignment}>
            {rightItems.map((item, i) => (
              <React.Fragment key={i}>
                {renderItem(item.icon, item.label, item.target, item.value)}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

interface Props {
  is_sticky?: boolean;
  items: {
    icon: string;
    label: string;
    position: "left" | "right";
    target: "_self" | "_blank" | "_parent" | "_top";
    value: string;
  }[];
}
